import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CalculatedChargeModel } from 'src/models/CalculatedChargeModel';
import { FilterAbstractModel } from 'src/models/FilterAbstractModel';

@Component({
  selector: 'app-calculated-bandwidth-filter',
  templateUrl: './calculated-bandwidth-filter.component.html',
  styleUrls: ['./calculated-bandwidth-filter.component.scss']
})
export class CalculatedBandwidthFilterComponent  extends FilterAbstractModel  implements OnInit {
  @Input() calculateBandDataInput: [] = [];
  @Input() calculateBandSelected: string;
  @Output() onCalculateBandChange = new EventEmitter();

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.calculateBandSelected) {
      this.calculateBandSelected = this.calculateBandSelected;
    }
  }


  handleCalculateBandChange = (event) => {
    this.onCalculateBandChange.emit(event.value);
  };
}
